import { constants } from '~/utils/EmbeddingFeed/ConfirmMessage/constants';

/**
 * Формирует стили
 * @returns string - тег style для встраивания в head страницы
 */
const configureConfirmMessageStyles = (hash: string): string => {
  return `
    <style id="${constants.ID_CONFIRM_MESSAGE_STYLES_BLOCK}${hash}">
      .message-parent-element__${hash} {
        width: 296px;
        padding: 10px;
        background-color: #00BD7E;
        border: 1px solid rgba(255, 255, 255, 0.5);
        color: white;
        position: fixed;
        top: calc(100% - 108px);
        left: calc((100% - 296px) / 2);
        box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        z-index: 9999;
      }

      .message-text__${hash} {
        font-family: Inter;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        color: #FFFFFF;
      }

      .button-selection-wrapper__${hash} {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 12px;
      }

      .buttons-confirm-message__${hash} {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        padding: 9px 16px 6px 16px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 6px;
        font-family: Inter;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        letter-spacing: -0.03em;
        color: #FFFFFF;
        cursor: pointer;
      }

      .__self-color__${hash} {
        background-color: #00BD7E;
      }

      .buttons-confirm-message-icon__${hash} {
        margin-right: 6px;
      }

    </style>
  `;
};

/**
 * Интегрирует в блок head стили
 */
export const addStyles = (hash: string): void => {
  const head = document.getElementsByTagName('head')[0];
  head.insertAdjacentHTML(
    'beforeend',
    configureConfirmMessageStyles(hash)
  );
};

/**
 * Удаляет стили из блока head
 * @param hash
 */
export const removeStyles = (hash: string) => {
  document
    .getElementById(
      `${constants.ID_CONFIRM_MESSAGE_STYLES_BLOCK}${hash}`
    )
    .remove();
};
